import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LangContext } from "@/i18n";
import CookieBanner from "@/components/CookieBanner";
import HomePage from "@/pages/HomePage";
import AccessoPage from "@/pages/AccessoPage";
import PerspectivesIndex from "@/pages/PerspectivesIndex";
import PerspectiveArticle from "@/pages/PerspectiveArticle";
import ManifestoPage from "@/pages/ManifestoPage";
import LegalPage from "@/pages/LegalPage";

function App() {
  const [lang] = useState("en");
  const setLang = () => {};

  useEffect(() => {
    document.documentElement.lang = "en";
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 2.4, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/accesso" element={<AccessoPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/cookie-policy" element={<LegalPage kind="cookie" />} />
          <Route path="/perspectives" element={<PerspectivesIndex />} />
          <Route path="/perspectives/:slug" element={<PerspectiveArticle />} />
          <Route path="/noise-is-not-luxury" element={<ManifestoPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </LangContext.Provider>
  );
}

export default App;
